import { FC } from "react";
import { Switch } from "@mui/material";
import { SwitchStyle } from "./helper";

interface CustomSwitchProps {
  checked: boolean;
  handleChange: () => void;
}

const CustomSwitch: FC<CustomSwitchProps> = ({ checked, handleChange }) => {
  return (
    <Switch
      checked={checked}
      onChange={handleChange}
      sx={SwitchStyle}
      disableRipple
    />
  );
};

export default CustomSwitch;
